export const STREAM_FOLLOW_THRESHOLD_PX = 72;

export function isNearStreamBottom(element, threshold = STREAM_FOLLOW_THRESHOLD_PX) {
  if (!element) return false;
  return element.scrollHeight - element.scrollTop - element.clientHeight <= threshold;
}

export function isUpwardStreamScroll(previousScrollTop, nextScrollTop) {
  return nextScrollTop < previousScrollTop - 1;
}
